export default __webpack_public_path__ + "static/media/trade-bg.a13fabf1.jpg";